module.exports = __webpack_public_path__ + "img/video2.3ace7da6.png";